import React, { useContext, useEffect } from 'react';
import { AppSettings } from '../../config/app-settings';
import { useListPlatformsQuery } from '../../redux/Api/PlatformApiSlice';
import LinksInsertion from '../../components/LinkInsertion/LinksInsertion';
import TextAreaInsertion from '../../components/LinkInsertion/TextAreaInsertion';
import Loader from '../pages/loader';
import { can } from '../../helpers/auth';
import NoPermission from '../pages/noPermission';
import { toast } from 'react-toastify';

function ContentIDLinkInsertionInstagram() {
	const { data: platforms, isLoading, isFetching, error } = useListPlatformsQuery({
		platform_name__icontains: 'Instagram',
		page: '*',
		ordering: '-id',
		fields: ['id'].join(',')
	})

	const context = useContext(AppSettings);
	useEffect(() => {
		context.setAppHeaderNone(false);
		context.setAppSidebarNone(false);
		context.setAppContentClass('');
		context.setAppThemePanal(true)

		return function cleanUp() {
			context.setAppHeaderNone(true);
			context.setAppSidebarNone(true);
			context.setAppContentClass('p-0');
			context.setAppThemePanal(false)
		};
	}, []);

	useEffect(() => {
		if (error?.data) {
			const errorMessages = Object.values(error.data).flat()
			errorMessages.forEach(message => {
				toast.error(message)
			})
		}
	}, [error])

	if (!can("add_videourl")) {
        return <NoPermission />
    }
	
	return (
		<div className='flex flex-col gap-8'>
			<Loader isLoading={isLoading || isFetching}/>
			{platforms?.results ? <>
				<LinksInsertion
					platform_name="Instagram"
					platformId={platforms?.results[0]?.id}
					matchText={[/instagram\.com/]}
					isContentID={true}
				/>
				<TextAreaInsertion
					platform_name="Instagram"
					platformId={platforms?.results[0]?.id}
					matchText={[/instagram\.com/]}
					isContentID={true}
				/>
			</> : null}
		</div>
	)
}

export default ContentIDLinkInsertionInstagram;